import { tint, shade } from "polished";
// theme.js

// breakpoint values
// any array length works with styled-system
const breakpoints = ["40em", "52em", "64em"];

const colors = {
  text: "#363636",
  violet: "#7673c0",
  ash: "#363636",
  blue: "#4698CB",
  green: "#1CAB42",
  pink: "#E56DB1",
  orange: "#DF4A17",
  yellow: "#ED8B00",
  lightgrey: "#EBEBEB",
  dark: {
    violet: shade(0.75, "#7673c0"),
    blue: shade(0.75, "#4698CB"),
    green: shade(0.75, "#1CAB42"),
    pink: shade(0.75, "#E56DB1"),
    orange: shade(0.75, "#DF4A17"),
    yellow: shade(0.75, "#ED8B00")
  },
  light: {
    violet: tint(0.75, "#7673c0"),
    blue: tint(0.75, "#4698CB"),
    green: tint(0.75, "#1CAB42"),
    pink: tint(0.75, "#E56DB1"),
    orange: tint(0.75, "#DF4A17"),
    yellow: tint(0.75, "#ED8B00")
  },
  grey: ["#363636", "#EBEBEB", "#fff"]
};

// space is used for margin and padding scales
// it's recommended to use powers of two to ensure alignment
// when used in nested elements
// numbers are converted to px
const space = [0, 4, 8, 16, 24, 32, 48, 64, 96, 128, 256, 512];

const fonts = {
  sans: "'Noto Sans', system-ui, sans-serif",
  mono: "monospace"
};

// typographic scale
const fontSizes = [11, 14, 16, 20, 24, 30, 44, 64, 96, 128];

// for any scale, either array or objects will work
const lineHeights = [1, 1.125, 1.25, 1.5];

const fontWeights = {
  normal: 500,
  bold: 700
};

const letterSpacings = {
  normal: "normal",
  headings: "-0.025em",
  caps: "0.075em"
};

// border-radius
const radii = [0, 2, 4, 8];

const borders = [0, "1px solid", "2px solid"];

const shadows = [`0 1px 2px 0 ${colors.text}`, `0 1px 4px 0 ${colors.text}`];

const theme = {
  breakpoints,
  colors,
  space,
  fonts,
  fontSizes,
  lineHeights,
  fontWeights,
  letterSpacings,
  radii,
  borders,
  shadows
};

export default theme;



// WEBPACK FOOTER //
// ./src/theme.js